import React from "react";
import BSInput from "./BSInput";

const CustomRangeFilter = ({
    type,
    label,
    dateFrom,
    dateTo,
    currencyFrom,
    currencyTo,
    numberRangeFrom,
    numberRangeTo,
    setDateFrom,
    setDateTo,
    setCurrencyFrom,
    setCurrencyTo,
    setNumberRangeFrom,
    setNumberRangeTo,
}) => {
    const rangeConfig = {
        date: {
            labelText: "Date Range:",
            inputType: "date",
            fromId: "dateFrom",
            toId: "dateTo",
            fromValue: dateFrom,
            toValue: dateTo,
            onFromChange: (e) => setDateFrom(e.target.value),
            onToChange: (e) => setDateTo(e.target.value),
        },
        currency: {
            labelText: `${label} Range:`,
            startAdornment: "$",
            fromId: "from",
            toId: "to",
            extraStyles: { width: "100px" },
            fromValue: currencyFrom,
            toValue: currencyTo,
            onFromChange: (e) => setCurrencyFrom(e.target.value),
            onToChange: (e) => setCurrencyTo(e.target.value),
        },
        numberRange: {
            labelText: `${label} Range:`,
            fromId: "from",
            toId: "to",
            extraStyles: { width: "100px" },
            fromValue: numberRangeFrom,
            toValue: numberRangeTo,
            onFromChange: (e) => setNumberRangeFrom(e.target.value),
            onToChange: (e) => setNumberRangeTo(e.target.value),
        },
    };

    const config = rangeConfig[type];

    return (
        <React.Fragment>
            <label style={{ whiteSpace: "nowrap" }}>{config.labelText}</label>
            <BSInput
                id={config.fromId}
                value={config.fromValue}
                onChange={config.onFromChange}
                type={config.inputType}
                startAdornment={config.startAdornment}
                extraFormControlStyles={{
                    marginBottom: "0px",
                    ...config.extraStyles,
                }}
                extraInputStyles={{ marginTop: "0px" }}
            />
            <div style={{ color: "grey" }}>&mdash;</div>
            <BSInput
                id={config.toId}
                value={config.toValue}
                onChange={config.onToChange}
                type={config.inputType}
                startAdornment={config.startAdornment}
                extraFormControlStyles={{
                    marginBottom: "0px",
                    ...config.extraStyles,
                }}
                extraInputStyles={{ marginTop: "0px" }}
            />
        </React.Fragment>
    );
};

export default CustomRangeFilter;
